<script setup lang="ts">
const contentStore = useContentStore();
const { landingPageContent } = storeToRefs(contentStore);
</script>
<template>
    <div v-if="landingPageContent?.cityCards?.length" class="container">
        <mr-typography
            v-if="landingPageContent?.cityCardsTitle"
            type="h2"
            size="large"
            weight="900"
            color="var(--gray-900)"
        >
            {{ landingPageContent?.cityCardsTitle }}
        </mr-typography>
        <div class="plane-tickets-container">
            <a
                v-for="ticket in landingPageContent.cityCards"
                :key="ticket.id"
                class="plane-ticket-link"
                :href="ticket.link"
            >
                <div class="plane-ticket-item">
                    <mr-lazy-img
                        class="pic"
                        :src="ticket.image"
                        :alt="ticket.imageAlt"
                    />
                    <div class="mask" />
                    <mr-typography
                        size="x-small"
                        align="center"
                        color="white"
                        class="caption"
                    >
                        {{ ticket.cityTitle }}
                    </mr-typography>
                </div>
            </a>
        </div>
    </div>
</template>
<style scoped lang="scss">
.container {
    display: flex;
    flex-direction: column;
    gap: 16px;
    padding-top: 16px;
    @include mobile-only(1232px) {
        padding-inline: 16px;
        margin-inline: 0 !important;
    }
    .plane-tickets-container {
        display: flex;
        justify-content: flex-start;
        text-align: right;
        flex-wrap: wrap;
        width: 100%;
        gap: 16px;
        @include no-scrollbar;
        @include mobile-only {
            border-right: none;
            border-bottom: 3px solid usePalette($p-cool-gray, $p-100);
            overflow: auto;
            flex-wrap: nowrap;
            padding: 0;
        }

        &:last-child {
            border-bottom: none;
        }

        .plane-ticket-link {
            border-radius: 16px;
            overflow: hidden;
            flex-shrink: 0;

            .plane-ticket-item {
                position: relative;
                width: 136px;
                height: 194px;

                .mask {
                    background: linear-gradient(
                        180deg,
                        rgba($color: usePalette($p-blue, $p-500), $alpha: 0)
                            46.35%,
                        usePalette($p-blue, $p-200) 100%
                    );
                    border-radius: 16px;
                    transform: matrix(-1, 0, 0, 1, 0, 0);
                    position: absolute;
                    top: 0;
                    width: 136px;
                    height: 194px;
                }

                .pic {
                    width: 136px;
                    height: 194px;
                }

                .caption {
                    position: absolute;
                    bottom: 23.5px;
                    left: 50%;
                    transform: translateX(-50%);
                }
            }
        }
    }
}
</style>
